import React from 'react';
import { Grid } from '@nextiva/next-ui-components';

export const ShadowDom = () => {
  const rows = [];

  for (let i = 0; i < 5; i++) {
    rows.push(
      <div className="m-create-team__shadow__row" key={`shadow_row${i}`}>
        <Grid container>
          <Grid item xs={12}>
            <div className="m-create-team__shadow__row__check-box" />
            <div className="m-create-team__shadow__row__avatar" />
            <div className="m-create-team__shadow__row__user-info" />
          </Grid>
        </Grid>
      </div>,
    );
  }

  return <div className="m-create-team__shadow">{rows}</div>;
};
